import { currencyDisplay, localeCurrency } from '../cldr';

export default function formatCurrencySymbol(info, options) {
    if ( options === void 0 ) options = {};

    if (!options.currency) {
        options.currency = localeCurrency(info, true);
    }

    var display = currencyDisplay(info, options);

    return display;
}

//# sourceMappingURL=format-currency-symbol.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/numbers/format-currency-symbol.js
// module id = ../../../../@telerik/kendo-intl/dist/es/numbers/format-currency-symbol.js
// module chunks = 3